/**
 * Accounting Connectors API Service
 */

import type {
  ConnectorConfig,
  CreateConnectorInput,
  ConnectionTestResult,
  SyncResult,
  SyncLog,
} from '../types/accounting-connectors.types';
import { fetchWithAuth, safeJsonParse } from '@/utils/api';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1';
const API_BASE = `${API_URL}/accounting-connectors`;

async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const error = await safeJsonParse(response).catch(() => ({ message: 'Request failed' }));
    throw new Error((typeof error.error === 'object' ? error.error?.message : error.error) || error.message || 'Request failed');
  }
  const data = await safeJsonParse(response);
  return data.data;
}

export const accountingConnectorsAPI = {
  /**
   * Get connector configuration
   */
  async getConfig(): Promise<ConnectorConfig> {
    const response = await fetchWithAuth(`${API_BASE}/config`, {

    });
    return handleResponse<ConnectorConfig>(response);
  },

  /**
   * Save connector configuration
   */
  async saveConfig(config: CreateConnectorInput): Promise<ConnectorConfig> {
    const response = await fetchWithAuth(`${API_BASE}/config`, {
      method: 'POST',

      body: JSON.stringify(config),
    });
    return handleResponse<ConnectorConfig>(response);
  },

  /**
   * Test connection
   */
  async testConnection(): Promise<ConnectionTestResult> {
    const response = await fetchWithAuth(`${API_BASE}/test`, {
      method: 'POST',

    });
    return handleResponse<ConnectionTestResult>(response);
  },

  /**
   * Manual sync
   */
  async sync(): Promise<SyncResult> {
    const response = await fetchWithAuth(`${API_BASE}/sync`, {
      method: 'POST',

    });
    return handleResponse<SyncResult>(response);
  },

  /**
   * Get sync logs
   */
  async getLogs(): Promise<SyncLog[]> {
    const response = await fetchWithAuth(`${API_BASE}/logs`, {

    });
    return handleResponse<SyncLog[]>(response);
  },
};

// Re-export for backwards compatibility
export const accountingConnectorsService = {
  api: accountingConnectorsAPI,
};
